import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "../../../shared/api";
import type { IUniformModel } from "../models/IUniformModel";
import { useNotification } from "~hooks/useNotification";

export const useDeleteUniform = () => {
  const { sport, organizationId } = useParams();
  const { mutateData } = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation({
    mutationFn: (uniform: IUniformModel) => {
      return mutateData({
        url: `${sport}/o/${organizationId}/uniforms/${uniform.uniformId}?forceDelete=true`,
        method: "DELETE",
      });
    },
    onSuccess: async (response: any, uniform: IUniformModel) => {
      if (response?.data && response.data.length > 0) {
        if (response?.data && response.data.length > 0 && response.data[0]?.success === true) {
          await queryClient.invalidateQueries({
            queryKey: ["uniformItems", sport, organizationId, uniform.uniformId],
          });

          await queryClient.invalidateQueries({
            queryKey: ["uniforms", sport, organizationId, uniform.baseType, uniform.baseId],
          });

          notification.success({
            message: formatMessage({ id: "uniform.delete.success" }),
            placement: "bottomRight",
          });
        }
      }
    },
  });
};
